export default __webpack_public_path__ + "static/media/gallery_05.871f00c4.jpg";